import { axiosPrivate } from "../../api/axios";
import handleError from "../../hooks/handleError";





// Save Transactions ("Save Changes")
const saveTransactions = (transactions) => {

    let isMounted = true;
    const controller = new AbortController();

    const TransToInsert = transactions.filter((row) => row.actions === "INSERT");
    const TransToUpdate = transactions.filter((row) => row.actions === "UPDATE");
    const TransToDelete = transactions.filter((row) => row.actions === "DELETE");

    const insertTransactions = async (TransToInsert) => {
        try {
            await axiosPrivate.post("/transactions",
                TransToInsert,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const updateTransactions = async (TransToUpdate) => {
        try {
            await axiosPrivate.put("/transactions",
                TransToUpdate,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const deleteTransactions = async (TransToDelete) => {
        try {
            await axiosPrivate.post("/transactions/delete",
                TransToDelete,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    if (TransToDelete.length > 0) { deleteTransactions(TransToDelete) };
    if (TransToInsert.length > 0) { insertTransactions(TransToInsert) };
    if (TransToUpdate.length > 0) { updateTransactions(TransToUpdate) };

};
export default saveTransactions